export const iconFontAwesomeShoppingCcDinersClub = (
	<i className="fa-solid fa-cc-diners-club"></i>
);
